export default __webpack_public_path__ + "static/media/id5_hd.bd27c662.svg";